import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & { children: ReactNode };

export function PrimaryButton({ children, className, ...rest }: Props) {
  return (
    <button type="button" className={`btn-primary${className ? ` ${className}` : ''}`} {...rest}>
      {children}
    </button>
  );
}
